import { CircleText, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { numberToABC } from '@doltech/utils/lib/text';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { SingleAnswerMain } from '../../../student-do-test-questions/SingleAnswer';
import {
  DoTestSingleAnswerQuestionInstance,
} from '../../../student-do-test/model/Question/do-test-single-answer-question.store';

export interface SingleAnswerSubjectProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestSingleAnswerQuestionInstance;
  isPdfContent: boolean;
}

const CircleTextWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const Main = styled(SingleAnswerMain)`
  box-shadow: unset;
  border: unset;
  pointer-events: none;
  .question-option-wrapper {
    padding: 4px 0;
  }
`;

const ImageContainer = styled.div`
  margin-bottom: 16px;
  text-align: center;
`;

const Img = styled.img`
  max-width: 100%;
  height: auto;
`;

const selectImageToShow = (image, mobileImage, isMobile) => {
  if (isMobile) {
    return mobileImage || image;
  }
  // Desktop view.
  return image;
};

export const SingleAnswerSubject = observer((props: SingleAnswerSubjectProps) => {
  const { data, isPdfContent, ...rest } = props;
  const { question, isImageIncluded, image, mobileImage, options, formattedQuestionNo } = data;
  const { isMobile } = useDeviceDetect();

  return (
    <Main className="dol-question single-answer" {...rest}>
      <CircleText
        className="question-no-wrapper"
        circleText={formattedQuestionNo}
        displayMode={QuestionDisplayMode.QUESTION_NO_VIEW_SUBJECT}
        text={question}
      />
      {isImageIncluded && (
        <ImageContainer>
          <Img
            loading="lazy"
            src={selectImageToShow(image, mobileImage, isMobile && !isPdfContent).url}
            alt={question}
          />
        </ImageContainer>
      )}

      <div className="question-option-list">
        {options.map((option, index) => {
          const { key, value } = option;
          return (
            <CircleTextWrapper key={key}>
              <CircleText
                className="question-option-wrapper"
                circleText={numberToABC(index + 1)}
                displayMode={QuestionDisplayMode.QUESTION_OPTION_VIEW_SUBJECT}
                text={value}
              />
            </CircleTextWrapper>
          );
        })}
      </div>
    </Main>
  );
});
